import { Link, useRecordContext } from 'react-admin';

const SectionsLinkField = () => {
    const record = useRecordContext();
    if (!record) {
        return null;
    }
    return (
        <Link to={`/test-series/${record.testSeriesId}/tests/${record.id}/sections`}>
            <div style={{ whiteSpace: 'nowrap' }}>Sections</div>
        </Link>
    );
};

SectionsLinkField.defaultProps = {
    label: 'Sections',
};

export default SectionsLinkField;
